export default "__VITE_ASSET__D26Z5o16__"